<template>
  <el-cascader
    ref="cascaderRef"
    v-model="currentValue"
    :options="categoryOptions"
    :props="cascaderProps"
    :placeholder="placeholder"
    :size="size"
    :clearable="clearable"
    :filterable="filterable"
    :disabled="disabled"
    :show-all-levels="showAllLevels"
    style="width: 100%"
    @change="handleChange"
  >
    <template slot-scope="{ node, data }">
      <span>{{ data.label }}</span>
      <span v-if="!node.isLeaf">
        ({{ data.children ? data.children.length : 0 }})
      </span>
    </template>
  </el-cascader>
</template>

<script>
export default {
  name: 'DictCascader',
  props: {
    value: {
      type: [String, Number, Array],
      default: '',
    },
    placeholder: {
      type: String,
      default: '请选择物料分类',
    },
    size: {
      type: String,
      default: 'small',
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    filterable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showAllLevels: {
      type: Boolean,
      default: false,
    },
    // 是否需要同步mainMaterialCategoryCode和detailMaterialCategoryCode
    syncCodes: {
      type: Boolean,
      default: false,
    },
    amzSkuMaterialGroup: { type: String, default: '' },
  },
  data() {
    return {
      currentValue: this.value,
      categoryOptions: [],
      cascaderProps: {
        emitPath: false,
        checkStrictly: false,
        value: 'value',
        label: 'label',
        children: 'children',
      },
    }
  },
  watch: {
    value(newVal) {
      this.currentValue = newVal
    },
  },
  mounted() {
    this.loadCategoryOptions()
  },
  methods: {
    async loadCategoryOptions() {
      try {
        const res = await this.$api.materialCategoryTreeV1Api({
          materialCodeList:
            this.amzSkuMaterialGroup === 'packaging'
              ? ['d24ddeab-5ee4-41b2-bcc5-b3f3524a83a3']
              : ['1ab7e2b2-5b3d-45f9-950a-a552489998e9'],
          ignoreFabric: 'Y',
        })
        if (res.body && res.body.data) {
          this.categoryOptions = res.body.data
        }
      } catch (error) {
        console.error('Failed to load category options:', error)
      }
    },
    handleChange(value) {
      this.$emit('input', value)

      if (this.syncCodes) {
        this.$nextTick(() => {
          let mainCode = ''
          let detailCode = ''

          if (value) {
            const nodes = this.$refs.cascaderRef.getCheckedNodes()
            if (nodes && nodes.length > 0 && nodes[0].pathNodes) {
              const pathNodes = nodes[0].pathNodes

              pathNodes.forEach((node) => {
                const nodeData = node.data
                if (nodeData.classLevel === 1) {
                  mainCode = nodeData.value
                } else if (nodeData.classLevel === 2) {
                  detailCode = nodeData.value
                }
              })
            }
          }

          this.$emit('change', {
            value,
            mainMaterialCategoryCode: mainCode,
            detailMaterialCategoryCode: detailCode,
          })
        })
      } else {
        this.$emit('change', value)
      }
    },
  },
}
</script>
